import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { CardItemProp } from '~myAccount/pages/UserCards/types';
import { useAppDispatch } from '~/redux/hooks';
import { createExpiryDate } from '~/utils';

export default function DesktopCardItem({
  card,
  onDeleteItem,
  isLast,
}: CardItemProp) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  return (
    <div className={` ${!isLast ? 'border-b border-gray' : ''} py-2x px-3x`}>
      <div className="gap-7x grid grid-flow-col grid-cols-3 ">
        <div className="flex  gap-3x">
          <div className="flex element-center">
            <i
              className={`inline-block bg-cover w-[32px] h-[24px] ${card.card_brand.toLowerCase()}-icon `}
            />
          </div>
          <p className="text-body_1 text-gray__dark_1">{`XXXX-${card.card_last4}`}</p>
        </div>
        <p className="text-body_1 text-gray__dark_1">{card.card_holder_name}</p>
        <p className="text-body_2 text-gray__dark_1">
          {t('expiresIn')}
          <span className="text-body_1">
            {createExpiryDate({
              year: card.expiry_year,
              month: card.expiry_month,
            })}
          </span>
        </p>
        <button
          className="flex justify-end "
          onClick={() => {
            onDeleteItem(card.id);
            dispatch(openModal('deleteUserCard'));
          }}
          type="button"
        >
          <Icon name="delete" className="text-red_dark" />
        </button>
      </div>
    </div>
  );
}
